import { useState, useEffect } from "react";
import ConfirmacionQuiz from "../../../components/test/Quiz/ConfirmacionQuiz";
import QuizVideoIntro from "../../../components/test/Quiz/tutorial/QuizVideoIntro";
import { getConfirmacionStatusService } from "../../../services/confirmacion/confirmacion.service";
import "./layout.css";

const ConfirmacionTalentosPage = () => {
  const [started, setStarted] = useState(false);
  const [continuar, setContinuar] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const data = await getConfirmacionStatusService();
        if (data.todas_completadas) {
          setStarted(true);
        } else if (data.pregunta_index > 1 || data.talento_index > 1) {
          setContinuar(true);
        }
      } catch {
        // sin sesión → "Comenzar"
      } finally {
        setChecked(true);
      }
    };
    check();
  }, []);

  if (!checked) {
    return null;
  }

  if (!started) {
    return (
      <QuizVideoIntro
        tipo="inicio_confirmacion"
        titulo="Confirmación de Talentos"
        continuar={continuar}
        onStart={() => setStarted(true)}
      />
    );
  }

  return (
    <div className="quiz-page">
      <ConfirmacionQuiz />
    </div>
  );
};

export default ConfirmacionTalentosPage;
